/* acc_pd_lp_08_01 — LP 08 behaviour. Observer-driven; no raw scroll handlers. */
(function () {
  'use strict';

  var ROOT_SELECTOR = '.acc_pd_lp_08_01';
  var registry = [];

  function $(sel, root) {
    return (root || document).querySelector(sel);
  }

  function $$(sel, root) {
    return Array.prototype.slice.call((root || document).querySelectorAll(sel));
  }

  function on(el, type, fn, opts) {
    el.addEventListener(type, fn, opts);
    return function () {
      el.removeEventListener(type, fn, opts);
    };
  }

  /* -------------------------------------------------------------- reveal -- */

  function initReveal(root, teardown) {
    var items = $$('.pd08-reveal', root);
    if (!items.length || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        // Read every rect first, then write, so one element cannot force a
        // layout per callback.
        var hits = entries.filter(function (e) {
          return e.isIntersecting || e.boundingClientRect.top < 0;
        });
        hits.forEach(function (e) {
          e.target.classList.add('is-revealed');
          io.unobserve(e.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    // Read every rect before writing a single class, or each write forces the
    // next read to re-layout.
    var fold = window.innerHeight * 0.9;
    var tops = items.map(function (el) {
      return el.getBoundingClientRect().top;
    });

    for (var i = 0; i < items.length; i++) {
      // Above the fold already: revealing it only delays LCP.
      if (tops[i] < fold) {
        items[i].classList.add('is-revealed');
      } else {
        io.observe(items[i]);
      }
    }

    teardown.push(function () {
      io.disconnect();
    });
  }

  /* ---------------------------------------------------------- sticky CTA -- */

  function initStickyCta(root, teardown) {
    var sticky = $('[data-pd08-sticky]', root);
    var sentinel = $('[data-pd08-sticky-after]', root);
    if (!sticky || !sentinel || !('IntersectionObserver' in window)) return;

    // The bar shows once the sentinel is past, and hides again over the footer
    // so it never covers it.
    var state = { past: false, atFoot: false };

    function apply() {
      // The sentinel has no height, so an observer only fires on a real
      // transition; a deep link or restored scroll never produces one.
      state.past = sentinel.getBoundingClientRect().top < 0;
      var show = state.past && !state.atFoot;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }

    var io = new IntersectionObserver(
      function () {
        apply();
      },
      { threshold: 0 }
    );

    io.observe(sentinel);
    apply();
    teardown.push(function () {
      io.disconnect();
    });

    // The bar is redundant while the offer itself is on screen, and it covers
    // the footer, so both suppress it.
    var stops = [];
    // The add-to-cart itself, not the whole band: .pd08-buy__inner also wraps
    // the includes panel and the photo strip, which kept the bar down for
    // ~1200px after the real CTA had gone.
    var buy = $('[data-pd08-submit]', root) || $('.pd08-buy__form', root) || $('#pd08-buy', root);
    if (buy) stops.push(buy);

    var foot = $('[data-pd08-sticky-stop]', root) || $('.pd08-footer', root);
    if (foot) stops.push(foot);

    function anyStopInView() {
      for (var i = 0; i < stops.length; i++) {
        var r = stops[i].getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) return true;
      }
      return false;
    }

    if (stops.length) {
      var footIo = new IntersectionObserver(
        function () {
          state.atFoot = anyStopInView();
          apply();
        },
        { threshold: 0 }
      );
      stops.forEach(function (el) {
        footIo.observe(el);
      });
      teardown.push(function () {
        footIo.disconnect();
      });
    }

    // A zero-height sentinel only notifies on a transition, which a jump can
    // skip. One rAF-throttled read per frame keeps both edges honest.
    var queued = false;
    function onScroll() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(function () {
        queued = false;
        state.atFoot = anyStopInView();
        apply();
      });
    }

    teardown.push(on(window, 'scroll', onScroll, { passive: true }));
    onScroll();
  }

  /* ----------------------------------------------------------- countdown -- */

  function initCountdown(root, teardown) {
    $$('[data-pd08-countdown]', root).forEach(function (el) {
      var hEl = $('[data-cd="h"]', el);
      var mEl = $('[data-cd="m"]', el);
      var sEl = $('[data-cd="s"]', el);
      if (!hEl || !mEl || !sEl) return;

      var deadlineAttr = el.getAttribute('data-deadline');
      var fixed = deadlineAttr ? Date.parse(deadlineAttr) : NaN;

      function pad(n) {
        return (n < 10 ? '0' : '') + n;
      }

      function tick() {
        var now = new Date();
        var end;
        if (!isNaN(fixed)) {
          end = fixed;
        } else {
          // Rolls to the viewer's own midnight.
          end = new Date(now);
          end.setHours(24, 0, 0, 0);
        }
        var left = Math.max(0, end - now);
        hEl.textContent = pad(Math.floor(left / 36e5));
        mEl.textContent = pad(Math.floor((left % 36e5) / 6e4));
        sEl.textContent = pad(Math.floor((left % 6e4) / 1e3));
      }

      tick();
      var id = window.setInterval(tick, 1000);
      teardown.push(function () {
        window.clearInterval(id);
      });
    });
  }

  /* ------------------------------------------------------- anchor scroll -- */

  function initAnchorScroll(root, teardown) {
    $$('[data-pd08-scroll-to]', root).forEach(function (link) {
      teardown.push(
        on(link, 'click', function (e) {
          var target = $(link.getAttribute('data-pd08-scroll-to'), document);
          if (!target) return;
          e.preventDefault();
          var top = target.getBoundingClientRect().top + window.pageYOffset - 24;
          var from = window.pageYOffset;
          window.scrollTo({ top: top, behavior: 'smooth' });

          // Smooth scrolling is ignored in some contexts, and preventDefault has
          // already cancelled the native jump, so make sure the CTA still lands.
          window.setTimeout(function () {
            if (Math.abs(window.pageYOffset - from) > 2) return;
            // Re-measure: lazy images above the target move it after the click.
            var now = target.getBoundingClientRect().top + window.pageYOffset - 24;
            if (Math.abs(now - from) > 2) window.scrollTo(0, now);
          }, 220);
        })
      );
    });
  }

  /* ----------------------------------------------------------- accordion -- */

  function initAccordions(root, teardown) {
    $$('[data-pd08-accordion]', root).forEach(function (group) {
      var triggers = $$('[data-pd08-acc-trigger]', group);

      triggers.forEach(function (btn) {
        teardown.push(
          on(btn, 'click', function () {
            var panel = document.getElementById(btn.getAttribute('aria-controls'));
            var wasOpen = btn.getAttribute('aria-expanded') === 'true';

            triggers.forEach(function (other) {
              var p = document.getElementById(other.getAttribute('aria-controls'));
              other.setAttribute('aria-expanded', 'false');
              if (p) p.setAttribute('data-open', 'false');
            });

            if (!wasOpen && panel) {
              btn.setAttribute('aria-expanded', 'true');
              panel.setAttribute('data-open', 'true');
            }
          })
        );
      });
    });
  }

  /* --------------------------------------------------------- filter tabs -- */

  function initFilters(root, teardown) {
    $$('[data-pd08-filter]', root).forEach(function (group) {
      var tabs = $$('[data-pd08-filter-tab]', group);
      var scope = document.getElementById(group.getAttribute('data-pd08-filter')) || group;

      tabs.forEach(function (tab) {
        teardown.push(
          on(tab, 'click', function () {
            var want = tab.getAttribute('data-pd08-filter-tab');

            tabs.forEach(function (t) {
              var on_ = t === tab;
              t.classList.toggle('is-active', on_);
              t.setAttribute('aria-selected', on_ ? 'true' : 'false');
            });

            $$('[data-pd08-filter-item]', scope).forEach(function (item) {
              var tag = item.getAttribute('data-pd08-filter-item');
              item.hidden = !(want === '*' || tag === want);
            });
          })
        );
      });
    });
  }

  /* -------------------------------------------------------------- swiper -- */

  function initSwipers(root, teardown) {
    if (typeof window.Swiper !== 'function') return;

    $$('[data-pd08-swiper]', root).forEach(function (el) {
      var opts = {};
      try {
        opts = JSON.parse(el.getAttribute('data-pd08-swiper') || '{}');
      } catch (err) {
        opts = {};
      }

      var config = {
        loop: opts.loop !== false,
        speed: 420,
        spaceBetween: opts.spaceBetween || 20,
        slidesPerView: opts.slidesPerView || 1.15,
        grabCursor: true,
        watchOverflow: true,
        a11y: { enabled: true },
        keyboard: { enabled: true },
        breakpoints: opts.breakpoints || undefined
      };

      var next = $('[data-pd08-swiper-next]', el.parentNode);
      var prev = $('[data-pd08-swiper-prev]', el.parentNode);
      if (next && prev) {
        config.navigation = { nextEl: next, prevEl: prev };
      }

      var pagination = $('[data-pd08-swiper-pagination]', el.parentNode);
      if (pagination) {
        config.pagination = { el: pagination, clickable: true };
      }

      var instance = new window.Swiper(el, config);
      teardown.push(function () {
        if (instance && !instance.destroyed) instance.destroy(true, true);
      });
    });
  }

  /* ------------------------------------------------------------- buy box -- */

  function initBuyBox(root, teardown) {
    $$('[data-pd08-buybox]', root).forEach(function (box) {
      var dataEl = $('[data-pd08-variants]', box);
      if (!dataEl) return;

      var data;
      try {
        data = JSON.parse(dataEl.textContent);
      } catch (err) {
        return;
      }

      var swatches = $$('[data-pd08-swatch]', box);
      var qtyBtns = $$('[data-pd08-qty]', box);
      var thumbs = $$('[data-pd08-thumb]', box);
      var mainImg = $('[data-pd08-main-image]', box);
      var idInput = $('[data-pd08-variant-id]', box);
      var idInput2 = $('[data-pd08-variant-id-2]', box);
      var qtyInput2 = $('[data-pd08-qty-input-2]', box);
      var colourGroup2 = $('[data-pd08-colour-group="2"]', box);
      var qtyInput = $('[data-pd08-qty-input]', box);
      var priceEl = $('[data-pd08-price]', box);
      var compareEl = $('[data-pd08-compare]', box);
      var saveEl = $('[data-pd08-save]', box);
      var ctaLabel = $('[data-pd08-cta-label]', box);
      var submit = $('[data-pd08-submit]', box);

      // One selected variant per drum; slot 2 only matters on the 2-pack.
      var state = { id: String(data.selected || ''), id2: String(data.selected || ''), qty: 1 };

      function entry() {
        var byId = data.variants && data.variants[state.id];
        if (!byId) return null;
        return byId.tiers && byId.tiers[String(state.qty)] ? byId.tiers[String(state.qty)] : null;
      }

      var nameEl1 = $('[data-pd08-color-name="1"]', box);
      var nameEl2 = $('[data-pd08-color-name="2"]', box);
      var soldOutEl = $('[data-pd08-soldout]', box);
      var inStockEl = $('[data-pd08-instock]', box);

      function paint() {
        if (!data.variants) return;
        var v = data.variants[state.id];
        var t = entry();
        if (!v || !t) return;

        if (priceEl) priceEl.textContent = t.price;
        if (compareEl) {
          compareEl.textContent = t.compare || '';
          compareEl.hidden = !t.compare;
        }
        if (saveEl) {
          saveEl.textContent = t.save || '';
          saveEl.hidden = !t.save;
        }
        if (ctaLabel) ctaLabel.textContent = t.cta;
        if (nameEl1) nameEl1.textContent = v.title;
        if (nameEl2 && data.variants[state.id2]) nameEl2.textContent = data.variants[state.id2].title;

        if (idInput) idInput.value = state.id;
        // Two drums are two line items, so each can be a different colour.
        if (qtyInput) qtyInput.value = '1';
        if (colourGroup2) colourGroup2.hidden = state.qty < 2;
        if (idInput2) {
          idInput2.value = state.id2;
          idInput2.disabled = state.qty < 2;
        }
        if (qtyInput2) qtyInput2.disabled = state.qty < 2;
        if (state.qty < 2 && qtyInput) qtyInput.value = '1';

        if (submit) {
          submit.disabled = !v.available;
          submit.setAttribute('aria-disabled', v.available ? 'false' : 'true');
        }

        if (soldOutEl) soldOutEl.hidden = !!v.available;
        if (inStockEl) inStockEl.hidden = !v.available;
      }

      function selectThumb(btn) {
        thumbs.forEach(function (t) {
          var on_ = t === btn;
          t.classList.toggle('is-active', on_);
          t.setAttribute('aria-pressed', on_ ? 'true' : 'false');
        });
        var src = btn.getAttribute('data-pd08-thumb');
        if (mainImg && src) {
          mainImg.src = src;
          var srcset = btn.getAttribute('data-pd08-thumb-srcset');
          if (srcset) mainImg.srcset = srcset;
          else mainImg.removeAttribute('srcset');
          var alt = btn.getAttribute('data-pd08-thumb-alt');
          if (alt !== null) mainImg.alt = alt;
        }
      }

      swatches.forEach(function (sw) {
        teardown.push(
          on(sw, 'click', function () {
            var slot = sw.getAttribute('data-pd08-slot') === '2' ? 2 : 1;
            if (slot === 2) {
              state.id2 = sw.getAttribute('data-pd08-swatch');
            } else {
              state.id = sw.getAttribute('data-pd08-swatch');
            }

            // Only repaint the slot that was clicked.
            swatches.forEach(function (s) {
              if ((s.getAttribute('data-pd08-slot') === '2' ? 2 : 1) !== slot) return;
              var on_ = s === sw;
              s.classList.toggle('is-active', on_);
              s.setAttribute('aria-pressed', on_ ? 'true' : 'false');
            });

            var nameEl = $('[data-pd08-color-name="' + slot + '"]', box);
            var picked = data.variants[sw.getAttribute('data-pd08-swatch')];
            if (nameEl && picked) nameEl.textContent = picked.title;

            // Either drum's colour drives the gallery, so picking one always
            // shows what was just picked.
            var img = sw.getAttribute('data-pd08-swatch-image');
            if (img && thumbs[0]) {
              thumbs[0].setAttribute('data-pd08-thumb', img);
              var srcset = sw.getAttribute('data-pd08-swatch-srcset');
              if (srcset) thumbs[0].setAttribute('data-pd08-thumb-srcset', srcset);
              var tImg = thumbs[0].querySelector('img');
              if (tImg) {
                tImg.src = img;
                if (srcset) tImg.srcset = srcset;
              }
              selectThumb(thumbs[0]);
            }

            paint();
          })
        );
      });

      qtyBtns.forEach(function (btn) {
        teardown.push(
          on(btn, 'click', function () {
            state.qty = parseInt(btn.getAttribute('data-pd08-qty'), 10) || 1;
            qtyBtns.forEach(function (b) {
              var on_ = b === btn;
              b.classList.toggle('is-active', on_);
              b.setAttribute('aria-pressed', on_ ? 'true' : 'false');
            });
            paint();
          })
        );
      });

      thumbs.forEach(function (t) {
        teardown.push(
          on(t, 'click', function () {
            selectThumb(t);
          })
        );
      });

      paint();
    });
  }

  /* ---------------------------------------------------------------- boot -- */

  var FEATURES = [
    initReveal,
    initStickyCta,
    initCountdown,
    initAnchorScroll,
    initAccordions,
    initFilters,
    initSwipers,
    initBuyBox
  ];

  function initRoot(root) {
    if (root.__pd08) return;
    var teardown = [];
    root.__pd08 = teardown;
    root.classList.add('acc_pd_lp_08_01--js');

    // Isolated: a band whose markup a merchant has broken cannot stop the
    // add-to-cart or the accordions from binding.
    for (var i = 0; i < FEATURES.length; i++) {
      try {
        FEATURES[i](root, teardown);
      } catch (err) {
        if (window.console && console.warn) {
          console.warn('acc_pd_lp_08_01: ' + FEATURES[i].name + ' failed', err);
        }
      }
    }

    registry.push(root);
  }

  function destroyRoot(root) {
    var teardown = root.__pd08;
    if (!teardown) return;
    teardown.forEach(function (fn) {
      try {
        fn();
      } catch (err) {
        /* a failed teardown must not block the rest */
      }
    });
    delete root.__pd08;
    registry = registry.filter(function (r) {
      return r !== root;
    });
  }

  function boot(scope) {
    try {
      $$(ROOT_SELECTOR, scope || document).forEach(initRoot);
    } catch (err) {
      /* nothing to bind */
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      boot();
    });
  } else {
    boot();
  }

  // Swiper is deferred too, so it may land after this file.
  window.addEventListener('load', function () {
    if (typeof window.Swiper !== 'function') return;
    registry.forEach(function (root) {
      // Skip a root that has been torn down, or its teardowns would be dropped.
      if (!root.__pd08) return;
      if ($('[data-pd08-swiper].swiper-initialized', root)) return;
      try {
        initSwipers(root, root.__pd08);
      } catch (err) {
        /* a slider that will not start must not break the page */
      }
    });
  });

  // The theme editor tears sections down and rebuilds them.
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    $$(ROOT_SELECTOR, e.target).forEach(destroyRoot);
  });
})();
